
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { Languages } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';

export function LanguageToggle() {
  const { language, setLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const changeLanguage = (lang: 'en' | 'pl') => {
    setLanguage(lang);
    setIsOpen(false);
  };
  
  return (
    <div className="relative" ref={dropdownRef}>
      <Button
        variant="default"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className="rounded-md flex items-center justify-center hover:bg-primary/90 border-primary bg-primary text-primary-foreground"
        aria-label="Toggle language"
      >
        <Languages className="h-[1.2rem] w-[1.2rem] text-primary-foreground mr-2" />
        <span className="font-medium">{t('languageToggle.change')}</span>
      </Button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-36 rounded-lg shadow-lg bg-white dark:bg-zinc-900 ring-1 ring-black/5 dark:ring-white/10 glass-card p-1 animate-scale-in z-10">
          <div className="py-1">
            <button
              onClick={() => changeLanguage('en')}
              className={cn(
                "flex items-center w-full px-4 py-2 text-sm rounded-md",
                language === 'en'
                  ? "bg-primary/10 text-primary"
                  : "text-foreground hover:bg-secondary"
              )}
            >
              <span className="mr-2">🇬🇧</span> English
            </button>
            <button
              onClick={() => changeLanguage('pl')}
              className={cn(
                "flex items-center w-full px-4 py-2 text-sm rounded-md",
                language === 'pl'
                  ? "bg-primary/10 text-primary"
                  : "text-foreground hover:bg-secondary"
              )}
            >
              <span className="mr-2">🇵🇱</span> Polski
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
